export enum CmaLiteDeliveriesConfiguration {
    INTERNATIONAL_ISSUES = 'INTERNATIONAL_ISSUES',
    ALL_ISSUES = 'ALL_ISSUES'
}
